export enum SsoIntegrationFieldNames {
  ConnectionDetailsHeader = 'connectionDetailsHeader',
  ProviderPreset = 'providerPreset',
  Name = 'name',
  IconAttached = 'iconAttached',
  CompanyDomainIds = 'companyDomainIds',
  CompanyDomainIdsList = 'companyDomainIdsList',
  SsoConfigurationHeader = 'ssoConfigurationHeader',
  Code = 'code',
  RegenerateCodeButton = 'regenerateCodeButton',
  IdpMetadata = 'idpMetadata',
  ReadFromXmlButton = 'readFromXmlButton',
  ConfigTab = 'configTab',
  AttributeMapping = 'attributeMapping',
  JitProvisioningEnabled = 'jitProvisioningEnabled',
  TimeToleranceSeconds = 'timeToleranceSeconds',
  SyncUserAttributes = 'syncUserAttributes',
  AllowIdpInitiated = 'allowIdpInitiated',
  SpConfiguration = 'spConfiguration',
}

export enum SsoConfigTab {
  Attributes = 'attributes',
  Provisioning = 'provisioning',
  Advanced = 'advanced',
}

export enum AttributeMappingFieldNames {
  Attribute = 'attribute',
  MapsTo = 'mapsTo',
}

export const DEFAULT_TIME_TOLERANCE_SECONDS = 30;
